"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onAddDateFilter = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var antd_1 = require("antd");
var lodash_1 = require("lodash");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var types_1 = require("../../types");
var quick_1 = tslib_1.__importDefault(require("../../components/filter/quick"));
var utils_1 = require("../../utils");
var locale_1 = tslib_1.__importDefault(require("../../locale"));
var auto_complete_1 = tslib_1.__importDefault(require("./auto-complete"));
var OptionField = function (_a) {
    var id = _a.id, label = _a.label, shown = _a.shown, type = _a.type, onChange = _a.onChange, defaultValue = _a.defaultValue, onFilter = _a.onFilter;
    return (react_1.default.createElement("div", { key: id },
        react_1.default.createElement(antd_1.Radio, { value: id }, label),
        react_1.default.createElement("br", null),
        shown === id && (react_1.default.createElement(TextInput, { type: type, onChange: function (e) { return onChange(e.target.value); }, placeholder: locale_1.default.enterText, defaultValue: defaultValue, onPressEnter: function () { return onFilter(); } }))));
};
var IsNullField = function (_a) {
    var chosenCondition = _a.chosenCondition, conditionType = _a.conditionType, setValue = _a.setValue;
    var _b = (0, react_1.useState)(""), localValue = _b[0], setLocalValue = _b[1];
    var _c = (0, react_1.useState)(false), showOptions = _c[0], setShowOptions = _c[1];
    var options = [
        { label: locale_1.default.true, value: "true" },
        { label: locale_1.default.false, value: "false" },
    ];
    var updateValue = function (e) {
        e.stopPropagation();
        setLocalValue(e.target.value);
        setValue(e.target.value);
    };
    return (react_1.default.createElement(antd_1.Space, { direction: 'vertical' },
        react_1.default.createElement(antd_1.Radio, { value: conditionType, onClick: function () {
                setShowOptions(true);
            }, key: conditionType }, (0, lodash_1.startCase)(types_1.mapConditions[conditionType])),
        showOptions && chosenCondition === conditionType && (react_1.default.createElement(IsNullSpace, { direction: 'horizontal' },
            react_1.default.createElement(antd_1.Radio.Group, { onChange: function (e) { return updateValue(e); }, options: options, value: localValue })))));
};
var IsNullSpace = (0, styled_components_1.default)(antd_1.Space)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  margin-left: 25px;\n"], ["\n  margin-left: 25px;\n"])));
var FilterCondition = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-direction: column;\n"], ["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-direction: column;\n"])));
var TextInput = (0, styled_components_1.default)(antd_1.Input)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  width: 220px;\n  height: 30px;\n  padding-left: 5px;\n  color: #000000;\n  border: 1px solid #ebebeb;\n  border-radius: 4px;\n  margin: 5px 0 5px 25px;\n\n  &:focus {\n    outline: none;\n  }\n"], ["\n  width: 220px;\n  height: 30px;\n  padding-left: 5px;\n  color: #000000;\n  border: 1px solid #ebebeb;\n  border-radius: 4px;\n  margin: 5px 0 5px 25px;\n\n  &:focus {\n    outline: none;\n  }\n"])));
var DropDownAction = styled_components_1.default.div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  border-top: 1px solid #d7dbe7;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  border-top: 1px solid #d7dbe7;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var InnerContainer = styled_components_1.default.div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 10px 10px 10px 0;\n"], ["\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 10px 10px 10px 0;\n"])));
var Content = styled_components_1.default.div(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  margin-bottom: 15px;\n"], ["\n  margin-bottom: 15px;\n"])));
var onAddDateFilter = function (fn, key, date, applyURL, condition) {
    if (applyURL === void 0) { applyURL = true; }
    if (condition === void 0) { condition = []; }
    if (date.length != 2) {
        return;
    }
    var begin = (0, utils_1.parseDate)(date[0]).startOf("day").format("YYYY-MM-DDTHH:mm");
    var end = (0, utils_1.parseDate)(date[1]).endOf("day").format("YYYY-MM-DDTHH:mm");
    fn(key, null, [
        {
            condition: "__".concat((condition === null || condition === void 0 ? void 0 : condition[0]) || types_1.FILTER_CONDITION.GTE),
            value: begin,
        },
        { condition: "__".concat((condition === null || condition === void 0 ? void 0 : condition[1]) || types_1.FILTER_CONDITION.LTE), value: end },
    ], applyURL, true);
};
exports.onAddDateFilter = onAddDateFilter;
var Condition = function (_a) {
    var _b, _c, _d, _e, _f;
    var filter = _a.filter, filtersObject = _a.filtersObject, onAddFilter = _a.onAddFilter, onAppend = _a.onAppend, onRemoveFilter = _a.onRemoveFilter;
    var _g = (0, react_1.useState)(filter === null || filter === void 0 ? void 0 : filter.condition), condition = _g[0], setCondition = _g[1];
    var _h = (0, react_1.useState)(filter.options), value = _h[0], setValue = _h[1];
    var _j = (0, react_1.useState)(""), date = _j[0], setDate = _j[1];
    var onFilter = function (val, label) {
        var _a, _b, _c;
        if (val === void 0) { val = null; }
        if (label === void 0) { label = ""; }
        if ((0, lodash_1.isArray)(filter.condition)) {
            filter.condition.map(function (k) {
                if (k === types_1.FILTER_CONDITION.EQUALS) {
                    onRemoveFilter(filter.key);
                }
                else {
                    onRemoveFilter([filter.key, k].join("__"));
                }
            });
        }
        else {
            if (filter.condition === types_1.FILTER_CONDITION.EQUALS) {
                onRemoveFilter(filter.key);
            }
            else {
                onRemoveFilter([filter.key, filter.condition].join("__"));
            }
        }
        switch (filter.type) {
            case types_1.DATA_TYPE.TEXT:
            case types_1.DATA_TYPE.BOOLEAN:
            case types_1.DATA_TYPE.NUMBER:
                (_a = filtersObject === null || filtersObject === void 0 ? void 0 : filtersObject.data) === null || _a === void 0 ? void 0 : _a.map(function (f) {
                    if (f.key === filter.key) {
                        f.options = value;
                        f.condition = condition;
                        f.active = false;
                    }
                });
                // @ts-ignore
                onAppend(tslib_1.__spreadArray([], filtersObject.data, true));
                if (condition === types_1.FILTER_CONDITION.EQUALS || (0, lodash_1.isEmpty)(condition)) {
                    onAddFilter && onAddFilter(filter.key, "", value);
                    return;
                }
                onAddFilter && onAddFilter(filter.key, "__".concat(condition), value);
                return;
            case types_1.DATA_TYPE.DATETIME:
                if (!(0, lodash_1.isEmpty)(val) && (val === null || val === void 0 ? void 0 : val[0]) && (val === null || val === void 0 ? void 0 : val[1])) {
                    setDate(val || "");
                    (_b = filtersObject === null || filtersObject === void 0 ? void 0 : filtersObject.data) === null || _b === void 0 ? void 0 : _b.map(function (i) {
                        if (filter.key === i.key) {
                            i.value = val || "";
                        }
                    });
                    // @ts-ignore
                    onAppend(tslib_1.__spreadArray([], filtersObject === null || filtersObject === void 0 ? void 0 : filtersObject.data, true));
                    (0, exports.onAddDateFilter)(onAddFilter, filter.key, val);
                }
                return;
            case types_1.DATA_TYPE.CHOICE:
                var cond_1 = filter.condition || types_1.FILTER_CONDITION.IN;
                (_c = filtersObject === null || filtersObject === void 0 ? void 0 : filtersObject.data) === null || _c === void 0 ? void 0 : _c.map(function (f) {
                    if (f.key === filter.key) {
                        f.options = val || "";
                        f.label = label;
                        f.condition = cond_1;
                    }
                });
                // @ts-ignore
                onAppend(tslib_1.__spreadArray([], filtersObject === null || filtersObject === void 0 ? void 0 : filtersObject.data, true));
                if (cond_1 === types_1.FILTER_CONDITION.EQUALS) {
                    onAddFilter && onAddFilter(filter.key, "", val);
                }
                else {
                    onAddFilter && onAddFilter(filter.key, "__".concat(types_1.FILTER_CONDITION.IN), val);
                }
                return;
        }
    };
    var selectValue = (0, lodash_1.isEmpty)(filter.value) ? [] : filter.value;
    if (typeof selectValue === "string") {
        selectValue = selectValue.split(",");
    }
    var options = (_c = (_b = filtersObject === null || filtersObject === void 0 ? void 0 : filtersObject.list) === null || _b === void 0 ? void 0 : _b.find(function (v) { return v.key === filter.key; })) === null || _c === void 0 ? void 0 : _c.options;
    var autoComplete = (_e = (_d = filtersObject === null || filtersObject === void 0 ? void 0 : filtersObject.list) === null || _d === void 0 ? void 0 : _d.find(function (v) { return v.key === filter.key; })) === null || _e === void 0 ? void 0 : _e.autoComplete;
    return (react_1.default.createElement(FilterCondition, null,
        react_1.default.createElement(InnerContainer, null,
            react_1.default.createElement(Content, null,
                (filter.type === types_1.DATA_TYPE.TEXT ||
                    filter.type === types_1.DATA_TYPE.NUMBER ||
                    filter.type === types_1.DATA_TYPE.BOOLEAN) && (react_1.default.createElement(antd_1.Radio.Group, { onChange: function (val) {
                        if (filter.type === types_1.DATA_TYPE.BOOLEAN) {
                            setValue(val.target.value);
                            return;
                        }
                        setCondition(val.target.value);
                    }, value: filter.type === types_1.DATA_TYPE.BOOLEAN ? value : condition },
                    react_1.default.createElement(antd_1.Space, { direction: 'vertical' }, (_f = filter.supported) === null || _f === void 0 ? void 0 : _f.map(function (f) {
                        switch (f) {
                            case types_1.FILTER_CONDITION.FALSE:
                            case types_1.FILTER_CONDITION.TRUE:
                                return (react_1.default.createElement(antd_1.Space, { direction: 'vertical', key: f },
                                    react_1.default.createElement(antd_1.Radio, { value: f }, (0, lodash_1.startCase)(types_1.mapConditions[f]))));
                            case types_1.FILTER_CONDITION.ISNULL:
                                return react_1.default.createElement(IsNullField, { chosenCondition: condition, conditionType: f, setValue: setValue, key: f });
                            default:
                                return (react_1.default.createElement(OptionField, { key: f, id: f, label: (0, lodash_1.startCase)(types_1.mapConditions[f]), shown: condition, type: "text", onChange: setValue, defaultValue: filter.condition === f ? filter.options : undefined, onFilter: onFilter }));
                        }
                    })))),
                filter.type === types_1.DATA_TYPE.CHOICE && options && (react_1.default.createElement(antd_1.Select, { getPopupContainer: function (trigger) { return trigger.parentNode; }, onChange: function (val, k) {
                        if ((filter === null || filter === void 0 ? void 0 : filter.multipleMode) === false) {
                            onFilter(val, k === null || k === void 0 ? void 0 : k.children);
                            return;
                        }
                        onFilter(val, k === null || k === void 0 ? void 0 : k.map(function (k) { return k.children; }));
                    }, showAction: ["click"], value: selectValue, allowClear: true, autoFocus: true, mode: (filter === null || filter === void 0 ? void 0 : filter.multipleMode) === false ? undefined : "multiple", placeholder: locale_1.default.selectValue, showArrow: true, style: { minWidth: 150, maxWidth: 250, display: "block" }, 
                    // @ts-ignore
                    filterOption: function (input, option) { var _a; return (_a = option.children) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(input === null || input === void 0 ? void 0 : input.toLowerCase()); } }, options === null || options === void 0 ? void 0 : options.map(function (val, i) {
                    return (react_1.default.createElement(antd_1.Select.Option, { key: i, value: val.value }, val.label));
                }))),
                filter.type === types_1.DATA_TYPE.CHOICE && autoComplete && (react_1.default.createElement(auto_complete_1.default, { httpClient: autoComplete.client, label: autoComplete.label, url: autoComplete.url, labelKey: autoComplete.labelKey, mode: autoComplete.mode, onFilter: onFilter, valueKey: autoComplete.valueKey })),
                filter.type === types_1.DATA_TYPE.DATETIME && (react_1.default.createElement(quick_1.default, { value: date || filter.options, onChange: function (dateValues) {
                        onFilter(dateValues);
                    }, format: "DD.MM.YY" }))),
            filter.type !== types_1.DATA_TYPE.DATETIME && filter.type !== types_1.DATA_TYPE.CHOICE && (react_1.default.createElement(DropDownAction, null,
                react_1.default.createElement(antd_1.Button, { type: "link", onClick: function () { return onFilter(); } }, locale_1.default.done))))));
};
exports.default = Condition;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=condition.js.map